var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryflag2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10579_209354)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    transform: "translate(0.929688 0.853516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31438 17.6229C13.9451 17.6229 17.6991 13.8689 17.6991 9.23821C17.6991 4.60747 13.9451 0.853516 9.31438 0.853516C4.68364 0.853516 0.929688 4.60747 0.929688 9.23821C0.929688 13.8689 4.68364 17.6229 9.31438 17.6229Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66318 4.13281C2.00455 4.98972 1.50792 5.97738 1.21875 7.05033H5.58069L2.66318 4.13281Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4087 7.05029C17.1196 5.97738 16.6229 4.98972 15.9643 4.13281L13.0469 7.05029H17.4087Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21875 11.4258C1.50796 12.4987 2.00459 13.4864 2.66318 14.3432L5.58059 11.4258H1.21875Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4214 2.58704C13.5645 1.92841 12.5769 1.43178 11.5039 1.14258V5.50449L14.4214 2.58704Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21094 15.8901C5.06785 16.5487 6.0555 17.0453 7.12842 17.3345V12.9727L4.21094 15.8901Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12838 1.14258C6.05547 1.43178 5.06781 1.92841 4.21094 2.58701L7.12838 5.50445V1.14258Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5039 17.3345C12.5768 17.0453 13.5645 16.5487 14.4214 15.8901L11.5039 12.9727V17.3345Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0469 11.4258L15.9643 14.3433C16.6229 13.4864 17.1196 12.4987 17.4087 11.4258H13.0469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6281 8.14456H10.4081H10.4081V0.924491C10.05 0.877884 9.68504 0.853516 9.31438 0.853516C8.94365 0.853516 8.57872 0.877884 8.22073 0.924491V8.1445V8.14453H1.00066C0.954056 8.50255 0.929688 8.86755 0.929688 9.23821C0.929688 9.60894 0.954056 9.97387 1.00066 10.3319H8.22067H8.2207V17.5519C8.57872 17.5985 8.94365 17.6229 9.31438 17.6229C9.68504 17.6229 10.05 17.5986 10.408 17.5519V10.3319V10.3319H17.6281C17.6747 9.97387 17.6991 9.60894 17.6991 9.23821C17.6991 8.86755 17.6747 8.50255 17.6281 8.14456Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.4258L15.2415 15.1674C15.4136 14.9953 15.5778 14.8155 15.7344 14.6291L12.5311 11.4258H11.5V11.4258Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12829 11.4258H7.12822L3.38672 15.1673C3.55874 15.3394 3.73858 15.5035 3.92501 15.6601L7.12829 12.4568V11.4258Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12893 7.05023V7.05016L3.38739 3.30859C3.21531 3.48061 3.05115 3.66046 2.89453 3.84688L6.09784 7.0502H7.12893V7.05023Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.05084L15.2416 3.30924C15.0696 3.13715 14.8897 2.973 14.7033 2.81641L11.5 6.01972V7.05084Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10579_209354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    fill: "white",
    transform: "translate(0.929688 0.853516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryflag2);
export default __webpack_public_path__ + "static/media/Countryflag2.a8bc8d9d64bef07f1f618357a7ea74b2.svg";
export { ForwardRef as ReactComponent };